import React from 'react';
import { ReactComponent as PainIcon } from './icons/pain.svg';
import { ReactComponent as WorryIcon } from './icons/worry.svg';
import { ReactComponent as MoodIcon } from './icons/mood.svg';
import { ReactComponent as SleepIcon } from './icons/sleep.svg';
import { ReactComponent as SubstanceUseIcon } from './icons/substance-use.svg';
import { ReactComponent as TimeIcon } from './icons/time.svg';
import { ReactComponent as VideoIcon } from './icons/video.svg';
import { ReactComponent as AppIcon } from './icons/app.svg';
import { ReactComponent as CommunityIcon } from './icons/community.svg';
import { ReactComponent as ModuleIcon } from './icons/module.svg';
import { ReactComponent as PodcastIcon } from './icons/podcast.svg';
import { ReactComponent as WebsiteIcon } from './icons/website.svg';
import { ReactComponent as RecommendedIcon } from './icons/recommended-icon.svg';
import { CATEGORY } from './ResourceCategory';

export const selectIconByCategory = (category, iconStyle) => {
  switch (category) {
    case CATEGORY.worry:
      return <WorryIcon style={iconStyle} />;
    case CATEGORY.mood:
      return <MoodIcon style={iconStyle} />;
    case CATEGORY.sleep:
      return <SleepIcon style={iconStyle} />;
    case CATEGORY.substanceUse:
      return <SubstanceUseIcon style={iconStyle} />;
    case CATEGORY.recommended:
      return <RecommendedIcon style={iconStyle} />;
    default:
      return <PainIcon style={iconStyle} />;
  }
};

export const selectIconByMediaType = (type, iconStyle) => {
  switch (type) {
    case 'Video':
    case 'Vidéo':
      return <VideoIcon style={iconStyle} />;
    case 'App':
      return <AppIcon style={iconStyle} />;
    case 'Module':
      return <ModuleIcon style={iconStyle} />;
    case 'Podcast':
    case 'Balado':
      return <PodcastIcon style={iconStyle} />;
    case 'Community':
    case 'Communauté':
      return <CommunityIcon style={iconStyle} />;
    default:
      return <WebsiteIcon style={iconStyle} />;
  }
};

export const getTimeIcon = (iconStyle) => {
  return <TimeIcon style={iconStyle} />;
};
